export enum Authority {
  Admin = 1,
  Edit = 2,
  Sales = 3
}

export enum ExpireTermsStatus {
  None = 0,
  Warning = 1,
  Expired = 2
}

export const ROLE_ADMIN = 'admin';
export const ROLE_EDIT = 'edit';
export const ROLE_SALES = 'sales';

export const MAX_PER_PAGE = 100000000;

export const DEF_MAX_LENGTH = 255;
